import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';

import { useJobContext } from 'pages/Job/context';

export interface JobContentCheckoutHook {
  isLoading: boolean;
  job: Job | undefined;
  jobCompanyInfo: JobCompanyInfo | undefined;
}

export default function useJobContentCheckout(): JobContentCheckoutHook {
  const { isLoading, job, jobCompanyInfo } = useJobContext();

  return {
    isLoading,
    job,
    jobCompanyInfo,
  };
}
